'use client';
var classes = {"root":"m_abbac491","item":"m_abb6bec2","itemWrapper":"m_75cd9f71","itemIcon":"m_60f83e5b"};

export { classes as default };
//# sourceMappingURL=List.module.css.mjs.map
